export enum EProductTourStatus {
  COMPLETED = 'COMPLETED',
  SKIPPED = 'SKIPPED',
  NOT_STARTED = 'NOT_STARTED'
}

export enum EProductTourType {
  DASHBOARD_PRODUCT_TOUR = 'dashboardProductTour',
  COURSE_PRODUCT_TOUR = 'courseProductTour',
  ACTIVITIES_PRODUCT_TOUR = 'activitiesProductTour',
  FLASHCARDS_PRACTICE_PRODUCT_TOUR = 'flashcardPracticeProductTour',
  PROBLEM_REPORTS_PRODUCT_TOUR = 'problemReportsProductTour',
  PROBLEM_REPORT_DETAIL_PRODUCT_TOUR = 'problemReportDetailProductTour',
  NEW_TEACHER_SIDE_MENU_TOUR = 'newTeacherSideMenuTour',
  TASK_PANEL_PRODUCT_TOUR = 'taskPanelProductTour',
  VOICE_SESSION_PRODUCT_TOUR = 'voiceSessionProductTour'
}

export enum EProductTourTargets {
  PROGRESS_WIDGET = 'PROGRESS_WIDGET',
  QUIZ_MODE_WIDGET = 'QUIZ_MODE_WIDGET',
  LIVE_CLASSES_WIDGET = 'LIVE_CLASSES_WIDGET',
  EXAM_GROUPS_WIDGET = 'EXAM_GROUPS_WIDGET',
  SUBSCRIPTIONS_WIDGET = 'SUBSCRIPTIONS_WIDGET',
  POSTS_WIDGET = 'POSTS_WIDGET',
  RANKINGS_WIDGET = 'RANKINGS_WIDGET',
  PLANIFICATION_WIDGET = 'PLANIFICATION_WIDGET',
  PRODUCT_TOUR_ACTIONS = 'PRODUCT_TOUR_ACTIONS',
  LESSONS_TAB = 'LESSONS_TAB',
  FAVORITE_LESSONS_TAB = 'FAVORITE_LESSONS_TAB',
  SECTION_TRACKING_SELECTOR = 'SECTION_TRACKING_SELECTOR',
  SECTION_TRACKING_FILTER = 'SECTION_TRACKING_FILTER',
  UMY_TAB = 'UMY_TAB',
  QUESTIONS_TAB = 'QUESTIONS_TAB',
  ACTIVITIES_TAB = 'ACTIVITIES_TAB',
  NOTES_TAB = 'NOTES_TAB',
  FIRST_STEPS = 'FIRST_STEPS',
  PROBLEM_REPORTS_OPEN_TAB = 'PROBLEM_REPORTS_OPEN_TAB',
  PROBLEM_REPORTS_FILTERS = 'PROBLEM_REPORTS_FILTERS',
  PROBLEM_REPORT_STATUS_CELL = 'PROBLEM_REPORT_STATUS_CELL',
  TEACHER_MENU_GROUPED_SECTIONS = 'TEACHER_MENU_GROUPED_SECTIONS',
  TEACHER_MENU_INCIDENTS_ITEM = 'TEACHER_MENU_INCIDENTS_ITEM',
  TEACHER_MENU_TASK_PANEL_ITEM = 'TEACHER_MENU_TASK_PANEL_ITEM',
  VOICE_SESSION_BUTTON = 'VOICE_SESSION_BUTTON'
}
